import { Component, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService,DealerService,SpinnerService } from '../services';
import { NgxPermissionsService } from 'ngx-permissions';
import { HttpClient } from '@angular/common/http';
import { first, map } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { interval } from 'rxjs/observable/interval';
import { Inotification } from '../models/notification';
import * as moment from 'moment';
import { User } from '../models';
import { SlicePipe } from '@angular/common';
import { error } from '@angular/compiler/src/util';
import { analyzeAndValidateNgModules } from '@angular/compiler';
@Component({
    selector: 'toplayout',
    templateUrl: './top-layout.component.html'
})
export class TopLayoutComponent  implements OnInit 
{
    
    currentUser: User;
    statusTypes: any;
    showNoties: boolean =false;
    highlightedDiv : any;
    notifications: any;
    notificationsCount: number = 0;
    SltnotiIds: any = '';
    notificationTitle: any;
    selectedNotification: any;
    comments: any;
    notificationId: any;
    status_id: any = null;
    Notification :any;
    notificationSuccessMessage: boolean = false;
    viewNotification: boolean = false;
    UnreadedNotificationCountCheck: boolean = false;
    UnreadedNotificationCount: any = 0;
    commentserror: boolean = false;
    statuserror: boolean = false;
    resolved_status_id: any;
    FileType: any;
    FileSource: any;
    viewSourceOfDealer: any;
    DealerCode: any;
    DaysSinceFileNotRecieved: any;
    status: any;
    content: any;
    public showDM: Boolean = true;
    public showUM: Boolean = false;
    public showCDK: Boolean = false;
    public showRM: Boolean = false;
    public showRP: Boolean = false;
    public showLCF: Boolean = false;
    public showN: boolean = false;
    public showFb:boolean=false;
    private subscription: Subscription = new Subscription();
    ToggledStatus: boolean = false;
    UserEmail: any;
    UserFirstName: any;
    UserLastName: any;
    fromValue:any = "settings";
    constructor(private router: Router,
        private authenticationService: AuthenticationService,
        private ngxPermissionsService: NgxPermissionsService,
        private dealerService: DealerService,private http: HttpClient,
        private spinnerService: SpinnerService
    ) 
    {
        var user = this.authenticationService.getAuthorizationToken()
        if (user) {
            this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
            this.UserFirstName = this.currentUser.firstName;
            this.UserLastName = this.currentUser.lastName;
            this.UserEmail = this.currentUser.email; 
        }
        else {
            this.router.navigate(['/login']);
        }
        if (this.router.url === '/dealer/home') {
            this.showDM = true;
            this.showUM = false;
            this.showCDK = false;
            this.showRM = false;
            this.showLCF = false;
            this.showFb=false;
        }
        else if (this.router.url === '/user/home') {
            this.showDM = false;
            this.showUM = true;
            this.showCDK = false;
            this.showRM = false;
            this.showLCF = false;
            this.showFb=false;
        }
        else if (this.router.url === '/dealerCdk/homecdk') {
            this.showDM = false;
            this.showUM = false;
            this.showCDK = true;
            this.showRM = false;
            this.showLCF = false;
            this.showFb=false;
        }
        else if (this.router.url === '/dealer/rm') {
            this.showDM = false;
            this.showUM = false;
            this.showCDK = false;
            this.showRM = true;
            this.showLCF = false;
            this.showFb=false;
        }
        else if (this.router.url === '/reports/home') {
            this.showDM = false;
            this.showUM = false;
            this.showCDK = false;
            this.showRM = false;
            this.showRP = true;
            this.showLCF = false;
            this.showFb=false;
        }
        else if (this.router.url === '/lcert/home') {
            this.showDM = false;
            this.showUM = false;
            this.showCDK = false;
            this.showRM = false;
            this.showLCF = true;
            this.showFb=false;
        }
        else if(this.router.url === '/fb/home')
        {
            this.showDM = false;
            this.showUM = false;
            this.showCDK = false;
            this.showRM = false;
            this.showLCF = false;
            this.showN = false;
            this.showFb=true;
        }

       
    }

    GetUserByUserId()
    {
        this.spinnerService.start();
        this.authenticationService.getUserByUserId(this.currentUser.userId).pipe(first()).subscribe(data => {
            localStorage.setItem('RedirectFrom','Settings');
            this.spinnerService.stop();
            this.router.navigate(['/user/edit', data[0].UserGuid]);
        });
    }

    logout() {
        this.spinnerService.start();
        var user = this.authenticationService.getAuthorizationToken()
        this.authenticationService.logout(user);
        this.ngxPermissionsService.flushPermissions();
        this.spinnerService.stop();
        this.router.navigate(['/login']);
    }
    tooggleClickEvent(){
        this.ToggledStatus = !this.ToggledStatus; 
        if(this.ToggledStatus == true){
            localStorage.setItem('togglestatus','toggled');
        }else{
            localStorage.setItem('togglestatus','');

        }
         
    }
    
    ngOnInit(): void {
        
    }
    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.viewNotification = true; 
    }
   
}
